<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{$t('MODALLISTARFUNCIONARIOS.LISTARFUNCIONARIOS')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">
            <b-notification type="is-warning">
                <h5 class="is-size-5">{{$t('SISTEMA.ATENCAO')}}</h5>                
                <p>{{$t('MODALLISTARFUNCIONARIOS.AVISO')}}</p>
            </b-notification>
            <div class="panel">
                 
                <p  class="panel-block">
                    <b-field :label="$t('GUIAATENDIMENTO.AMBIENTES')">
                    </b-field>
                </p>                
                <div class="panel-block"> 
                    <table  v-if="funcionarios !=null && funcionarios.length>0"   class="table  is-fullwidth is-striped">
                        <thead>
                            <tr>
                                <th>
                                    <b-checkbox  @input="changedAll()"
                                                    size="is-small" type="is-info"  v-model="selecionadoTodos"></b-checkbox >                                                                                                                        
                                </th>
                                <th>Código</th>
                                <th>Nome</th>
                                <th>Email</th>                                 
                                                                                                     
                            </tr>                                                
                        </thead>
                        <tbody>                                                
                            <tr v-for="(funcionario, index) in funcionarios" :key="index">
                                
                                <td>
                                        <b-checkbox  @input="changed(funcionario)"
                                        size="is-small" type="is-info"  v-model="funcionario.selecionado"></b-checkbox >                                    
                                </td> 
                                
                                <td>{{ funcionario.codigoExterno  }}</td>
                                <td>{{ funcionario.nome  }}</td>
                                <td>{{ funcionario.email  }}</td>
                                                                                                                           
                            </tr>
                        </tbody>                        
                    </table>  
                </div>                     
                            

            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                     :loading="salvandoDados"
                      @click="confirmar">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click="$emit('close'); ">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import http from '@/http'
    import { mapState } from 'vuex'
    
    export default {
        props: {                 
        },
        data() {
            return {                                              
                salvandoDados :false,                
                funcionarios:[],
                funcionariosSelecionados:[], 
                selecionadoTodos:false               
            }
        },
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),  
        },        

        mounted() {                        
            this.loadFuncionarios();
        },
        methods: {


            changedAll(){

                if(this.selecionadoTodos){

                    this.funcionarios.forEach((item) => {
                        item.selecionado=true;
                        this.changed(item);
                    });                    

                }else{

                    this.funcionarios.forEach((item) => {
                        item.selecionado=false;
                        this.changed(item);
                    });                        

                }
                
            },               
            changed(funcionario){

                if(funcionario.selecionado){
                    this.funcionariosSelecionados.push(funcionario);
                }else{
                    this.funcionariosSelecionados = this.funcionariosSelecionados.filter(x=>x.id != funcionario.id);
                }
                    
            },               
            loadFuncionarios() {    
                this.salvandoDados = true;   
                
                const params = [];                                                                                                      

                params.push(`unidadeId=${this.unidadeId}`); 
                
                http.get(`/api/integracao/ListarFuncionariosEList?${params.join('&')}`)                        
                    .then(res => res.data)
                    .then(data => {     
                        this.funcionarios = data;                       
                        this.isLoading=false;
                    }).finally(() => {                                
                        this.salvandoDados = false;                                                                                  
                    });               
                    
            },                        

            atualizarFuncionarios(){    
                    this.salvandoDados=true;
                                                                                                    
                    http.post(`/api/manutencao/AtualizarFuncionario`,this.funcionariosSelecionados)
                    .then(() => {
                        this.salvandoDados=false;
                    }).finally(() => {                                
                        this.salvandoDados = false;                         
                        this.$emit('loadData');                                                          
                        this.$emit('close');                                                          
                    });  
                
            },              
 
            async confirmar() {
                              
                if(this.funcionariosSelecionados.length<=0){
                        this.$buefy.dialog.alert({
                            title: this.$t('SISTEMA.ATENCAO'),
                            message: this.$t('MODALLISTARFUNCIONARIOS.MENSAGEMSELECIONEFUNCIOANRIOS'),
                            type: 'is-warning',
                            hasIcon: true
                        }); 
                        return false;                              
                }else{
                        this.atualizarFuncionarios();                                        
                }
                
      
                
            },
            

        }
    }
</script>
